<template>
  <form @submit.prevent='submit_form' :class='{ errors: $v.$error }' novalidate>

    <div class="row">
      <div class='form-group col m6'>
        <select v-model='cameraBrand' @change="clear_camera_model">
          <option disabled selected value="">Camera Brand</option>
          <option v-for="brand in cameraBrands" :key="brand">{{brand}}</option>
        </select>
        <div class='error' v-if='!$v.cameraBrand.required'>Camera Brand is required</div>
      </div>
      <div class='form-group col m6'>
        <div v-if="cameraBrand == 'Other'">
          <input v-model="cameraModel" type="text" placeholder="Type camera brand/model" autofocus>
          <div class='error' v-if='!$v.cameraModel.required'>Camera brand/model is required</div>
        </div>
        <div v-else>
          <v-select v-model="cameraModel" :options="model_options" label="model_formatted" :reduce="c => c.model" placeholder="Camera Model" :disabled="!cameraBrand"></v-select>
          <div class='error' v-if='!$v.cameraModel.required'>Camera Model is required</div>
        </div>
      </div>
    </div>

    <div v-if="supportedCamera" class="notice" style="text-align: center"><p>Your camera, the {{supportedCamera}}, is supported on Arsenal 2 and Arsenal 2 Pro!<br>Get yours  <a href="/order">here</a>.</p></div>

    <button :disabled='submitting' class='btn'>Submit</button>
  </form>
</template>

<script>
  import cameras from 'app/cameras.json'
import SpinnerButton from 'app/components/shared/SpinnerButton'
import find from 'lodash/find'
import includes from 'lodash/includes'
import { required } from 'vuelidate/lib/validators'

  export default {
    props: ['kickstarter_url'],
    data() {
      return {
        submitting: false,
        supportedCamera: '',
        cameras: cameras,
        cameraBrands: Object.keys(cameras).concat('Other'),
        cameraBrand: '',
        cameraModel: '',
        email: this.$cookie.get('unsupported-camera-email')
      }
    },
    validations: {
      cameraBrand: { required },
      cameraModel: { required },
    },
    computed: {
      model_options() {
        return this.cameras[this.cameraBrand]
      },
      selected_camera() {
        if (this.cameraBrand == '' || this.cameraBrand == 'Other') {
          return null
        }
        return find(this.cameras[this.cameraBrand], { model: this.cameraModel })
      },
    },
    methods: {
      clear_camera_model() {
        this.cameraModel = ''
      },
      submit_form() {
        this.$v.$touch()

        if (this.$v.$error) {
          let message = "Please specify a camera."
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          return
        }

        this.submitting = true

        let body = {
          list_id: '22a694be57cc0604cf2218d83464014d',
          email: this.email,
          camera_brand: this.cameraBrand,
          camera_model: this.cameraModel
        }

        this.$http.post(`/subscribers`, body).then(response => {
          this.submitting = false
          this.$v.$reset()
          this.$cookie.delete('unsupported-camera-email')
          this.supportedCamera = ''
          if (this.selected_camera && includes(this.selected_camera.arsenal_support, 2)) {
            this.supportedCamera = `${this.cameraBrand} ${this.selected_camera.model_formatted}`
          }
          this.cameraBrand = ''
          this.cameraModel = ''
          if (this.supportedCamera == '') {
            let message = 'Thanks for letting us know which camera you were interested in! We\'ll keep you updated as we add new cameras to Arsenal 2.'
            this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          }
        }, response => {
          this.submitting = false
          let message = 'Something went wrong. Please try again later.'
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
        })
      }
    },
    components: { SpinnerButton }
  }
</script>
